<template>
    <div class="prof-grid_defaultScreen">
        <div class="prof-grid">
            <router-link :to="{name: 'chart' , query: { chart: 'grid' }}" target="_blank">
                <i v-show="!fullStatus" class="icon-fullscreen"></i>
            </router-link>
            <div class="prof-grid_wrap prof-grid_wrap-full">
                <div class="prof-grid_row">
                    <div class="prof-grid_item">
                        <chart
                            :update="update"
                            :updateRight="updateRight"
                            :updateHeight="updateHeight"
                            :noti="false"
                            :mini="true">
                        </chart>
                    </div>
                    <div class="prof-grid_item">
                        <gistagram 
                            :update="update"
                            :updateRight="updateRight"
                            :updateHeight="updateHeight"
                            :mini="true">
                        </gistagram> 
                    </div>
                </div>
            </div>
            <div class="prof-grid_wrap prof-grid_wrap-full">
                <div class="prof-grid_row prof-grid_row-padding">
                    <div class="prof-grid_item">
                        <month
                            :updateRight="updateRight"
                            :updateHeight="updateHeight"
                            :summaryData="false"
                            :mini="true">
                        </month>
                    </div>
                    <div class="prof-grid_item">
                        <week
                            :updateRight="updateRight"
                            :updateHeight="updateHeight"
                            :summaryData="false"
                            :mini="true">
                        </week>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProfitChart from './sig-chart-profit-widget';
import ProfitGistogramm from './chartsForTabs/pofitInPercent/sig-profit-chart-strategy';
import ProfitOnMonth from './chartsForTabs/profitMonthCharts/sig-profitability-chart-month';
import ProfitOnWeek from './chartsForTabs/profitWeekCharts/sig-profitability-chart-week';
export default {
    components: {
        'chart':ProfitChart,
        'gistagram': ProfitGistogramm,
        'month':ProfitOnMonth,
        'week':ProfitOnWeek
    },
    props: {
        update:{default:true},
        updateHeight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false}
    }
}
</script>
<style lang="less" scoped>
.prof-grid {
    height: 100%;
    display: flex;
    flex-direction: column;
    &_fullScreen {
        height: 100vh;
        width: 100vw;
    }
    &_defaultScreen {
        width: 100%;
        height: 100%;
    }
    a {
        position: absolute;
        right: 23px;
        top:40px;
        z-index: 4;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        i {
            font-size: 20px;
            color:#adc4e1;
        }
    }
    &_wrap {
        //height: calc(100vh - 610px);
        flex-grow: 1;
        flex-basis: 50%;
        display: flex;
        flex-direction: column;
        margin-bottom: 0.5px;
        flex-wrap: wrap;
        justify-content: center;
        @media screen and (max-width: 1366px) {
            min-height: calc(100vh - 450px);
        }
        &-full {
            min-height: 50%;
        }
    }
    &_row {
        flex-grow: 2;
        //flex-shrink:0;
        //flex-basis: 50%;
        height: 50%;
        display: flex;
        &-padding {
            padding-bottom: 0.5px;
        }
    }
    &_item {
        flex-grow: 1;
        flex-basis: 50%;
        max-width: 50%;
        padding: 0.5px 0.5px 0px 0px;
        overflow: hidden;
        &:first-child {
            margin-right: 0.5px;
        }
    }
}
</style>
